import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { style: {"margin-left":"20px"} }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { style: {"margin-left":"8px"} }, "显示所有状态", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 新建合同 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_we_table = _resolveComponent("we-table")!
  const _component_page_wrapper = _resolveComponent("page-wrapper")!
  const _directive_active = _resolveDirective("active")!

  return (_openBlock(), _createBlock(_component_page_wrapper, null, {
    default: _withCtx(() => [
      _createVNode(_component_we_table, { onRegister: _ctx.register }, {
        name: _withCtx(({ text, record }) => [
          _withDirectives(_createVNode(_component_a_button, {
            type: "link",
            onClick: ($event: any) => (_ctx.jumpToContract(record, true, _ctx.reload))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(text ? text : '-'), 1)
            ]),
            _: 2
          }, 1032, ["onClick"]), [
            [_directive_active]
          ])
        ]),
        rd_state_name: _withCtx(({ text, record }) => [
          _createElementVNode("span", {
            style: _normalizeStyle(`color: ${record.rd_state_color}`)
          }, _toDisplayString(text ? text : '-'), 5)
        ]),
        rd_overdue_status: _withCtx(({ text, record }) => [
          _createElementVNode("span", {
            style: _normalizeStyle(`color: ${record.rd_overdue_status_color}`)
          }, _toDisplayString(text ? text : '-'), 5)
        ]),
        headerButton: _withCtx(() => [
          _createVNode(_component_a_select, {
            value: _ctx.filterType,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterType) = $event)),
            options: _ctx.dateRangeOptions,
            onChange: _ctx.reload,
            style: {"width":"240px !important"}
          }, null, 8, ["value", "options", "onChange"]),
          _createElementVNode("span", _hoisted_1, [
            _createVNode(_component_a_switch, {
              checked: _ctx.checked,
              "onUpdate:checked": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.checked) = $event))
            }, null, 8, ["checked"]),
            _hoisted_2
          ]),
          ((_ctx.isPurchasePage || _ctx.isBackupPage) && (!_ctx.hasPermission('RoleFinanceDataViewer') || _ctx.isGod))
            ? (_openBlock(), _createBlock(_component_a_button, {
                key: 0,
                type: "primary",
                onClick: _ctx.editNoBusinessContract
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["onRegister"])
    ]),
    _: 1
  }))
}